var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGiftIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#072C54",
  fillRule: "evenodd",
  d: "m7.51 4.534-6.285 7.265V7.493h-.74V4.534zM13.612 4.534v2.959h-.714v4.372H8.93V4.534z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#072C54",
  d: "M6.987 13.797H1.225v2.433h5.762zM12.899 13.797h-3.97v2.433h3.97z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#072C54",
  fillRule: "evenodd",
  d: "m3.699 11.865 3.3-3.8v3.8zM11.686 3.006l-3.5 1.126H5.949l-3.5-1.126.336-2.211 3.642 2.433.169-.314h.955l.158.3L11.354.795z",
  clipRule: "evenodd"
})));
export { SvgGiftIcon as ReactComponent };
export default "/_next/static/images/gift-icon.svg";